import { Text } from '@avanta/shared/components/Text';
import { Textarea } from '@avanta/shared/components/ui/Textarea';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { StepSection } from 'pages/AppointmentsReserve/components/ui/StepSection';
import {
  AppointmentsReservePayload,
  type AppointmentsReserveFormData,
} from 'pages/AppointmentsReserve/types';

export const Observations = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { setValue } = useFormContext<AppointmentsReserveFormData>();
  const commentsLabel = (
    <Trans
      ns={LOCIZE_NS.APPOINTMENTS}
      i18nKey="AppointmentsReserve.Steps.confirmation.commentsLabel"
      components={{
        span: <Text tag="span" variant="text-sm-regular" className="text-gray-400" />,
      }}
    />
  );
  return (
    <StepSection
      title={commentsLabel}
      className="flex flex-col gap-2"
      containerClassName="gap-2 mt-6 w-146"
    >
      <Text variant="text-sm-regular" className="text-denim-800">
        {t('AppointmentsReserve.Steps.confirmation.description')}
      </Text>
      <Textarea
        placeholder={t('AppointmentsReserve.Steps.confirmation.observations.placeholder')}
        className="min-h-26"
        onChange={e => setValue(AppointmentsReservePayload.observations, e.target.value)}
      />
    </StepSection>
  );
};
